<div [title]="tooltip">{{activityName}}<span class="revenueRecognition" *ngIf="isNonBillableActivity">NONBILL</span></div>
